import { render, staticRenderFns } from "./GoingPc.vue?vue&type=template&id=dc6bae76&scoped=true&"
import script from "./GoingPc.vue?vue&type=script&lang=js&"
export * from "./GoingPc.vue?vue&type=script&lang=js&"
import style0 from "./GoingPc.vue?vue&type=style&index=0&id=dc6bae76&prod&lang=css&"
import style1 from "./GoingPc.vue?vue&type=style&index=1&id=dc6bae76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6bae76",
  null
  
)

export default component.exports